/*
 *
 * BiometricDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 01-Apr-2025
*/

import React from 'react'
import { IonAlert } from '@ionic/react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import './BiometricDialog.scss'

const BiometricDialog = (props) => {
  const intl = useIntl()

  const handleChoice = (choice) => {
    props.actions.doBiometricChoice({ ...props.data, choice })
    props.actions.doHidePopup()
  }

  return (
    <IonAlert
      isOpen
      onDidDismiss={() => props.actions.doHidePopup()}
      header={intl.formatMessage({ id: 't.app.login.biometric.appBiometricPopUpTitle' })}
      message={intl.formatMessage({ id: 't.app.login.biometric.appBiometricPopUpSubTitle' })}
      cssClass='biometricAlertBreakLines'
      buttons={[
        { text: intl.formatMessage({ id: 't.app.login.biometric.appBiometricPopUpConfirmCta' }), role: 'confirm', handler: () => handleChoice('true') },
        { text: intl.formatMessage({ id: 't.app.login.biometric.appBiometricPopUpNotNowCta' }), role: 'cancel', handler: () => handleChoice('false') },
        { text: intl.formatMessage({ id: 't.app.login.biometric.appBiometricPopUpDontAskAgainCta' }), role: 'confirm', handler: () => handleChoice('never') }
      ]}
    />
  )
}

BiometricDialog.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object
}

BiometricDialog.defaultProps = {
  actions: {},
  data: {}
}

export default BiometricDialog
